export const environment = {
  production: true,
  API_URL: 'https://api-prod.kharaaj.com/api/v1/',
  BASE_URL: 'https://api-prod.kharaaj.com',
  blobURL: 'https://kharaaj.blob.core.windows.net/khraaj',
};
